import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const SortIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M19.9412 2H2"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7647 13.7647H2"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7647 7.88237H2"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5883 17.2941L17.2941 22L22 17.2941"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.2941 22V7.88237"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  ),
);

SortIcon.displayName = 'SortIcon';
